import React from "react";
import { Mail, Phone, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { contact } from "../mock";
import Reveal from "./Reveal";

const Contact = () => {
  const cards = [
    { icon: Mail, label: "Email", value: contact.email, href: `mailto:${contact.email}` },
    { icon: Phone, label: "Phone", value: contact.phone, href: `sms:${contact.smsNumber}` },
    { icon: MapPin, label: "Location", value: contact.area, href: "https://www.google.com/maps?q=Washington+DC" },
  ];

  return (
    <section id="contact" className="bg-navy text-white relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(191,157,87,0.12), transparent 70%)" }} />
      <div className="max-w-6xl mx-auto px-4 py-20 relative">
        <Reveal className="text-center mb-14">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">Get In Touch</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide mt-2">Contact Our Office</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
          <p className="text-white/70 mt-5 max-w-xl mx-auto">{contact.note}</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.label} delay={(i % 3) + 1}>
                <a
                  href={c.href}
                  target={c.label === "Location" ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  className="group h-full flex flex-col items-center text-center bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/50 hover:bg-white/[0.07]"
                >
                  <div className="w-16 h-16 rounded-2xl bg-gold flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110">
                    <Icon className="w-7 h-7 text-navy" />
                  </div>
                  <span className="text-[11px] font-bold tracking-widest uppercase text-gold mb-2">{c.label}</span>
                  <p className="text-white font-medium break-words">{c.value}</p>
                  <span className="inline-flex items-center gap-1 text-xs text-white/50 mt-4 group-hover:text-gold transition-colors">
                    {c.label === "Location" ? "Open in Maps" : c.label === "Email" ? "Send an email" : "Text us"}
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={2} className="mt-10 flex items-center justify-center gap-3 text-white/60 text-sm">
          <Clock className="w-4 h-4 text-gold" /> {contact.hours}
        </Reveal>

        <Reveal delay={2} className="mt-10 rounded-2xl overflow-hidden border border-white/10 h-72">
          <iframe
            title="Office Location"
            src="https://www.google.com/maps?q=Washington%20DC&output=embed"
            className="w-full h-full border-0"
            loading="lazy"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
